import { FC } from "react";
import { Button } from "react-bootstrap";
import "../../styles/EmployeeList.css";

interface Props {
  title: string;
  footer?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  children: string | JSX.Element | JSX.Element[];
}

const PageContainer: FC<Props> = (props) => {
  const { title, buttonText, onButtonClick, children } = props;

  return (
    <div
      className="content-wrapper"
      style={{ backgroundColor: "#F0F8FF", marginTop: "30px", padding: "10px" }}
    >
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-2 mt-3">
            <h1 className="mb-2 mb-sm-0">{title}</h1>
            {buttonText && (
              <div className="action-buttons">
                <Button className="custom-btn1" onClick={onButtonClick}>
                  {buttonText}
                </Button>
              </div>
            )}
          </div>
        </div>
      </section>
      <section className="content">{children}</section>
    </div>
  );
};

export default PageContainer;
